module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c07-ca1201188fd9e2e636274573442fe2e6.jpg";